import {useEffect, useRef} from 'react';

const MAX_RETRIES = 10;
const RETRY_INTERVAL_MS = 100;
const HIGHLIGHT_DURATION_MS = 2000;

export function useScrollToHash(): string | null {
	const hash = window.location.hash.slice(1) || null;
	const attemptedRef = useRef(false);

	useEffect(() => {
		if (!hash || attemptedRef.current) return;
		attemptedRef.current = true;

		let retries = 0;
		let timer: ReturnType<typeof setTimeout> | null = null;

		function tryScroll() {
			const el = document.getElementById(hash!);
			if (el) {
				el.scrollIntoView({behavior: 'smooth', block: 'center'});
				el.classList.add('deep-link-highlight');
				setTimeout(() => {
					el.classList.remove('deep-link-highlight');
				}, HIGHLIGHT_DURATION_MS);
				return;
			}
			retries++;
			if (retries < MAX_RETRIES) {
				timer = setTimeout(tryScroll, RETRY_INTERVAL_MS);
			}
		}

		tryScroll();

		return () => {
			if (timer != null) clearTimeout(timer);
		};
	}, [hash]);

	return hash;
}
